module.exports = __webpack_public_path__ + "static/img/female-bg-tr.6e15b1f8.png";